import { useRef } from "react";
import ModalPop from "./ModalPop";
import Inquiry from "./Inquiry";

const Contact = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <div
      id="contact"
      className="relative w-full h-full mx-auto pb-14 lg:pb-28 xl:pb-36 bg-white"
    >
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className=" relative w-full h-fit text-white py-5 lg:py-10">
        <img
          src="/images/contactTitle.png"
          alt="title"
          className="absolute left-0 top-0 w-full h-full"
        />
        {/* 상단 타이틀 */}
        <div
          className="text-center tracking-tighter px-[calc((100%-var(--container))/2)] lg:px-0"
          data-aos="fade-up"
        >
          <h3 className=" font-medium text-xl md:text-2xl">
            하수코솔루션의 도움이 필요하신가요?
          </h3>
          <h2 className="gbold leading-tight mt-3">
            <span className=" text-[#9cc3ff]">정직한 견적 + 확실한 해결</span>
            <br />
            고객감동을 실현하는 하수코솔루션
          </h2>
          <h3 className="font-medium text-base md:text-2xl my-5">
            365일 수도권 전지역 어디든지 긴급출동 <br />
            지금 바로 문의주세요
          </h3>
        </div>
      </div>
      <div className="my-8 lg:my-12">
        {/* CTA buttons */}
        <div className="mt-5 lg:mt-14">
          <img
            className="object-contain mx-auto max-h-16 lg:max-h-24"
            src="/images/logo.png"
            alt="하수코솔루션 네이버검색"
          />
        </div>
        <div className="mb-5 lg:mb-14">
          <img
            className="object-contain mx-auto max-h-10 lg:max-h-12"
            src="/images/num.png"
            alt="하수코솔루션 네이버검색"
          />
        </div>
      </div>
      <div className="relative w-full h-fit px-[calc((100%-var(--container))/2)] max-w-[1400px] mx-auto ">
        <Inquiry />
      </div>
    </div>
  );
};

export default Contact;
